import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from './Components/Navbar'
import OTPVerification from './Components/OTPVerification'
import SingUp from './Components/SingUp'
import Login from './Components/Login'
import AuthLayout from './Layouts/AuthLayout'
import Home from './Components/Home'
import Admin from './AdminPanel/Admin'
import AdminLayout from './Layouts/AdminLayout'
import UsersManagment from './AdminPanel/UsersManagment'
import ForgetPassword from './Components/ForgetPassword'
import Foods from './AdminPanel/Foods'
import ViewFood from './Components/ViewFood'
import Orders from './AdminPanel/Orders'
import ViewOrderStatus from './Components/ViewOrderStatus'

const App = () => {
  return (
        <BrowserRouter>
          <div className="fixed top-0 left-0 right-0 z-50">
            <Navbar />
          </div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/viewFood" element={<ViewFood />} />
            <Route path="/vieworders" element={<ViewOrderStatus />} />
            <Route path='/admin' element= {<AdminLayout/>}>
              <Route index  element={<Admin/>}/>
              <Route path='orders'  element={<Orders/>}/>
              <Route path='foods'  element={<Foods/>}/>
              <Route path='users'  element={<UsersManagment/>}/>
            </Route>
            <Route path="/auth" element={<AuthLayout />}>
              <Route path="login" element={<Login />} />
              <Route path="singup" element={<SingUp />} />
              <Route path="verifycode" element={<OTPVerification />} />
              <Route path="forgetpassword" element={<ForgetPassword />} />
            </Route>
          </Routes>
        </BrowserRouter>
  )
}

export default App
